import { MHTTPCL } from "./http/http-client"

export const FeedbackService = {
  submitFeedback: payload => {
    return MHTTPCL.postFormData('/feedback.pl', payload);
  }
}